import script from "./CountdownBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CountdownBanner.vue?vue&type=script&setup=true&lang=js"

import "./CountdownBanner.vue?vue&type=style&index=0&id=7d816d91&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d816d91"]])

export default __exports__